import Image from "next/image"
import { useTranslation } from "next-i18next";

const EasyManagementAndUserAddingAdvantages = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);

    return (
        <div className="container py-10 mx-auto lg:py-20">
            <div className="grid mx-auto lg:grid-cols-2">

                <div className="order-2 pt-4 lg:order-1 lg:pt-0 ">
                    <Image src={"/easyManagementAndUserAddingAdvantages.svg"} width={632} height={474} alt={t("email:easyManagementAndUserAddingAdvantages")} title={t("email:easyManagementAndUserAddingAdvantages")} />
                </div>

                <div className="order-1 px-2 lg:px-0">
                    <h2 className="pb-6 text-3xl font-bold text-titleColor lg:text-4xl">{t("email:easyManagementAndUserAddingAdvantages")}</h2>
                    <div className="space-y-5">
                        <div>
                            <h3 className="text-xl font-bold text-titleColor">{t("email:quickAccess")}</h3>
                            <p className="text-sm font-medium text-textGray lg:text-base">{t("email:quickAccessDesc")}</p>
                        </div>

                        <div>
                            <h3 className="text-xl font-bold text-titleColor">{t("email:savingTime")}</h3>
                            <p className="text-sm font-medium text-textGray lg:text-base">{t("email:savingTimeDesc")}</p>
                        </div>

                        <div>
                            <h3 className="text-xl font-bold text-titleColor">{t("email:flexibility")}</h3>
                            <p className="text-sm font-medium text-textGray lg:text-base">{t("email:flexibilityDesc")}</p>
                        </div>

                        <div>
                            <h3 className="text-xl font-bold text-titleColor">{t("email:simpleUsage")}</h3>
                            <p className="text-sm font-medium text-textGray lg:text-base">{t("email:simpleUsageDesc")}</p>
                        </div>

                        <div>
                            <h3 className="text-xl font-bold text-titleColor">{t("email:easeOfRoutingAndResponse")}</h3>
                            <div className="text-sm font-medium text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:easeOfRoutingAndResponseDesc") }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EasyManagementAndUserAddingAdvantages